import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    content: string;
}

function NoticeContent({ content }:Props) {
    const { i18n: { language } } = useTranslation();
    return (<div className={styles.wrapper}
        lang={language}
        dangerouslySetInnerHTML={{ __html: content }} />);
}

export default NoticeContent;
